import type { DropDownList } from '@syncfusion/ej2-dropdowns';

export async function d(fieldId: string, placeholder: string, data: { [key: string]: Object }[], hasError: boolean) {

    await import('@syncfusion/ej2-base/styles/bootstrap4.css');
    await import('@syncfusion/ej2-buttons/styles/bootstrap4.css');
    await import('@syncfusion/ej2-inputs/styles/bootstrap4.css');
    await import('@syncfusion/ej2-popups/styles/bootstrap4.css');
    await import('@syncfusion/ej2-lists/styles/bootstrap4.css');
    await import('@syncfusion/ej2-dropdowns/styles/bootstrap4.css');

    await import('./loadSyncfusion');

    const { DropDownList } = await import('@syncfusion/ej2-dropdowns');

    let containerEle = document.getElementById('container_' + fieldId);
    let inputEle = document.getElementById('input_' + fieldId);

    let dataEle = document.getElementById('data_' + fieldId);
    if (dataEle.hasAttribute("data-dropdownlist")) {
        (inputEle.parentNode as HTMLElement).classList.toggle('e-error', hasError);
        return;
    }

    dataEle.setAttribute('data-dropdownlist', 'true');
    const dataEleVal = dataEle.getAttribute('value');

    let ddObject: DropDownList = new DropDownList({
        // sets the placeholder
        floatLabelType: "Never",
        placeholder: null,
        dataSource: data,
        fields: { text: 'Text', value: 'Value' },
        value: dataEleVal,
        change: (args: any) => {
            dataEle = document.getElementById('data_' + fieldId);
            inputEle = document.getElementById('input_' + fieldId);

            dataEle.setAttribute('value', ddObject.value?.toString());
            (inputEle.closest("form").querySelector("button[type=submit]") as HTMLButtonElement).click();
        },
        created: (args: any) => {
            inputEle = document.getElementById('input_' + fieldId);
            containerEle = document.getElementById('container_' + fieldId);

            (inputEle.parentNode as HTMLElement).classList.toggle('e-error', hasError);
            containerEle.style.display = null;
        }
    });
    ddObject.appendTo('#input_' + fieldId);
}
